// import { useSelector } from "react-redux";
// import { Navigate } from "react-router-dom";
// import { normalizeRole } from "../utils/rbacHelper";

// export default function ProtectedRoute({ children, requiredRoles }) {
//   const user = useSelector((s) => s.auth.user);

//   // 1. Not logged in
//   if (!user) {
//     return <Navigate to="/login" replace />;
//   }

//   const userRole = normalizeRole(user.role);

//   // 2. Role Check
//   if (requiredRoles && !requiredRoles.map(normalizeRole).includes(userRole)) {

//     // 🛑 SMART REDIRECTS (USING EXACT ROLE STRINGS)

//     // Admin Staff → Admin Dashboard
//     if ([
//       'admin',
//       'manager',
//       'hr',
//       'field_emp',
//       'office_emp',
//       'sub_admin'
//     ].includes(userRole)) {
//       return <Navigate to="/admin-dashboard" replace />;
//     }

//     // Group Admin
//     if (userRole === 'group_admin') {
//       return <Navigate to="/admin-dashboard" replace />;
//     }

//     // User / Client
//     if (['user', 'client'].includes(userRole)) {
//       return <Navigate to="/admin-dashboard" replace />;
//     }

//     // Viewer
//     if (userRole === 'viewer') {
//       return <Navigate to="/admin-dashboard" replace />;
//     }

//     // Fallback
//     return <Navigate to="/admin-dashboard" replace />;
//   }

//   // 3. Access Granted
//   return children;
// }



import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { normalizeRole } from "../utils/rbacHelper";

export default function ProtectedRoute({ children, requiredRoles }) {
  const location = useLocation();
  const user = useSelector((s) => s.auth.user);
  const token = useSelector((s) => s.auth.token) || localStorage.getItem("token");

  // ✅ Token hai but user hydrate ho raha hai, redirect mat karo
  if (!user && token) {
    return (
      <div style={{ minHeight: "40vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        Loading...
      </div>
    );
  }

  if (!user && !token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const userRole = normalizeRole(user.role);

  if (requiredRoles && !requiredRoles.map(normalizeRole).includes(userRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
